import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatCardModule } from '@angular/material/card'

export interface LinkIconModel {
  id: string
  name: string
  type: string
  url?: string
  icon?: string
  petaboParam?: string
  kicocaParams?: any
}

@Component({
    selector: 'app-link-icon',
    imports: [MatCardModule, CommonModule],
    templateUrl: './link-icon.component.html',
    styleUrl: './link-icon.component.scss'
})
export class LinkIconComponent {
  @Input() icon!: LinkIconModel
  @Output() clicked = new EventEmitter()

  cardClicked(icon: any) {
    if (icon.url) {
      location.href = icon.url
    } else {
      this.clicked.emit(icon)
    }
  }
}
